import { Injectable, OnDestroy } from '@angular/core';
import { ErrorMessageBindingStrategy, ReactiveFormConfig } from '@rxweb/reactive-form-validators';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RxWebReactiveFormConfigService implements OnDestroy {
    private langChangeSubscription: Subscription;

    public constructor(private translateService: TranslateService) {
        // Subscribe to language changes
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(() => {
            this.init();
        });
    }

    public init(): void {
        ReactiveFormConfig.set({
            errorMessageBindingStrategy: ErrorMessageBindingStrategy.OnDirtyOrSubmit,
            validationMessage: {
                alpha: this.translateService.instant('validation.alpha'),
                alphaNumeric: this.translateService.instant('validation.alphaNumeric'),
                compare: this.translateService.instant('validation.compare'),
                contains: this.translateService.instant('validation.contains'),
                creditCard: this.translateService.instant('validation.creditCard'),
                digit: this.translateService.instant('validation.digit'),
                email: this.translateService.instant('validation.email'),
                greaterThan: this.translateService.instant('validation.greaterThan'),
                greaterThanEqualTo: this.translateService.instant('validation.greaterThanEqualTo'),
                hexColor: this.translateService.instant('validation.hexColor'),
                json: this.translateService.instant('validation.json'),
                lessThan: this.translateService.instant('validation.lessThan'),
                lessThanEqualTo: this.translateService.instant('validation.lessThanEqualTo'),
                lowerCase: this.translateService.instant('validation.lowerCase'),
                maxLength: this.translateService.instant('validation.maxLength'),
                maxNumber: this.translateService.instant('validation.maxNumber'),
                minLength: this.translateService.instant('validation.minLength'),
                minNumber: this.translateService.instant('validation.minNumber'),
                password: this.translateService.instant('validation.password'),
                pattern: this.translateService.instant('validation.pattern'),
                phone: this.translateService.instant('validation.phone'),
                range: this.translateService.instant('validation.range'),
                required: this.translateService.instant('validation.required'),
                time: this.translateService.instant('validation.time'),
                upperCase: this.translateService.instant('validation.upperCase'),
                url: this.translateService.instant('validation.url'),
                zipCode: this.translateService.instant('validation.zipCode'),
            },
        });
    }

    public ngOnDestroy(): void {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }
}
